export default __webpack_public_path__ + "static/adventcalendar-571f2f962a084f0e2ed053062a816344.png";